import { render, staticRenderFns } from "./verifikasi_ppbkl.vue?vue&type=template&id=718a20df&scoped=true"
import script from "./verifikasi_ppbkl.vue?vue&type=script&lang=js"
export * from "./verifikasi_ppbkl.vue?vue&type=script&lang=js"
import style0 from "./verifikasi_ppbkl.vue?vue&type=style&index=0&id=718a20df&prod&lang=scss"
import style1 from "./verifikasi_ppbkl.vue?vue&type=style&index=1&id=718a20df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "718a20df",
  null
  
)

export default component.exports